module.exports = __webpack_public_path__ + "static/soehne-web-kraftig-b7a0677e447cfcfd9f0284fe3610004f.woff";